import { DatePipe,Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, ViewChild ,Renderer2} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { LocationModel, Registration } from 'src/app/models/login/login';
import { RegistorpatientService } from 'src/app/services/registorpatient.service';
import { NgOtpInputComponent, NgOtpInputConfig } from 'ng-otp-input';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;
 
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  isValidEmail: boolean = true;
  isNotCellPhone: boolean = false;
  isNotValidPhone: boolean = false;
  isShowVerifyButton: boolean = false;
  registration: any;
  
  otpCountDown: any;
  isOtpentered: boolean = true;
  verifiedCellPhone: boolean = false;
  practice_code:any;
  practice_name:any;
  isDatePickerDisabled:boolean=false;
  @ViewChild(NgOtpInputComponent, { static: false })
  ngOtpInput!: NgOtpInputComponent;
  config: NgOtpInputConfig = {
    allowNumbersOnly: false,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    letterCase: 'Upper'
  };
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  maxDate:any;
  registrationForm: FormGroup = new FormGroup({});
  
  constructor(private translateService:TranslateService,private spinner: NgxSpinnerService, private _phrutilService: PhrutillsService, private _registor: RegistorpatientService, private datepipe: DatePipe,
    private _router:Router,private _route: ActivatedRoute,private location:Location
    ,private renderer: Renderer2) {
      this.registration = new Registration();
      this.maxDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.reset();
    }
    
    buildregistrationForm(){
      this.registrationForm = new FormGroup({
        location: new FormControl('', Validators.required),
        firstname: new FormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]),
        lastname: new FormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('^[a-zA-Z ]*$')]),    
        gender: new FormControl('', Validators.required),
        dob: new FormControl('', Validators.required),
        email: new FormControl('',Validators.email),
        cell: new FormControl('', [Validators.required,Validators.minLength(10)]),
      });
    }


    ngOnInit(): void {
      this._route.queryParams.subscribe((params: Params) => {
        localStorage.clear();
        if(params['practice_code']!=null ){
          this.VerifyPractice(params['practice_code']);
        }
        else
        {
          localStorage.clear();
          $("#isNotValid_link").modal("show");
          return;
        }
      }, error => {
        localStorage.clear();
        $("#isNotValid_link").modal("show");
        return;
      });
      this.loadExternalStyles('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0');
      this._phrutilService.setTitle('Verify Patient');
    }

    /* Load Material icons css from third party on this component to be used on datepicker
      angular material 
      Developer : - Asad Iftikhar
      Senior Software engineer Mursalin team
      12-25-2023
      Requirement from word file no Jira ticket specific available
      */
   loadExternalStyles(url: string) {
        const link = this.renderer.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
    
        this.renderer.appendChild(document.head, link);
      }
    focusOutFunction(e: any, type: any){
        if((new Date(this.maxDate)) < (new Date(this.registrationForm.get('dob')!.value)))
         {
         this.getregistrationForm.dob.setErrors({'maxDate': true, 'invalid': true});
       }
     }


    ValidatePersonalInfo(data: any, type: any) {
      let validname = data.target.value.replace(/[^a-zA-Z ]/g, "");
      data.target.value = validname;
      if (type == 'firstname') {
        if(validname!='')
        {
          this.registration.first_Name = validname;
        }else
        {
          this.registration.first_Name = validname;
        }
      } else if (type == 'lastname') {
        if(validname!='')
        {
          this.registration.last_Name = validname;
        }
        else
        {
          this.registration.last_Name = validname;
        }
      }
    }
    
    validatePhoneNo(field: any) {
      let phoneNumDigits = field.value.replace(/\D/g, '');
      field.value = phoneNumDigits;
      let isValidPhone = (phoneNumDigits.length == 0 || phoneNumDigits.length == 10);
      if (isValidPhone) {
        field.value = this._phrutilService.maskingPhoneNumer(phoneNumDigits);
      } else {
        field.value = phoneNumDigits;
      }
    }
    
    validatePhone(phoneNumDigits: any, type: any) {
      let dummyPhone = phoneNumDigits.replace(/\D/g, '');
      phoneNumDigits = dummyPhone.replace(/\s/g, '');
      if (type == "phone") {
        if (phoneNumDigits.length == 0 || phoneNumDigits.length == 14 || phoneNumDigits.length == 10) {
          this.isNotValidPhone = false;
          if (phoneNumDigits.length != 0) {
            this.isShowVerifyButton = true;
            this.isNotCellPhone = false;
          }
        }
        else {
          this.isNotValidPhone = true;
          this.isShowVerifyButton = false;
        }
      }
    }
    
    onFocusOutLocation(data: any, type: any) {
      
      if (data.value) {
        if (type == 'location') {
          this.registration.location_Code = data.value;
        }
        else if (type == 'gender') {
          this.registration.gender = data.value;
        }
      }
      
    }
    
    get getregistrationForm() {
      return this.registrationForm.controls;
    }
    
    reset() {
      this.registrationForm.reset();
      this.buildregistrationForm();
    }
    
    RegistrationResponce: any;
    RegistorPatient() {
      this.registrationForm.markAllAsTouched();
      if(this.providerLocation.length == 1 ){
          this.registrationForm.patchValue({
            location: this.providerLocation[0].locationCode,
          });
      }
    
     // if (!this.registrationForm.invalid && this.checkFieldValidaiton() && this.verifiedCellPhone && this.isValidEmail) {
        if (!this.registrationForm.invalid && this.checkFieldValidaiton() && this.isValidEmail) {
        this.spinner.show();
          this.registration.date_Of_Birth = this.datepipe.transform(new Date(this.registrationForm.get('dob')!.value), 'MM/dd/yyyy');
        this.registration.practice_Code = this.practice_code;
        this.registration.email_Address = this.registrationForm.get('email')!.value;
        // this.registration.location_Code = this.providerLocation && this.providerLocation.length == 1 ?
        // this.providerLocation[0].locationCode : this.registrationForm.get('location')!.value;
        this.registration.location_Code = this.registrationForm.get('location')!.value;
        this.registration.last_Name =this.registrationForm.get('lastname')!.value;
        this.registration.first_Name=this.registrationForm.get('firstname')!.value;
        this.registration.gender=this.registrationForm.get('gender')!.value;
        this.registration.cell_phone=this.registrationForm.get('cell')!.value.replace(/\D/g, '');
        this.registration.zip='';
        this.registration.state='';
        this.registration.city='';
        this.registration.address='';
        this.registration.created_By='Breeze check-in'
        this.registration.modified_By='';
        this._registor.RegistorPatient(this.registration).subscribe((res: any) => {
          this.spinner.hide();
          if (res.statusCode == 200 && res.message.toLowerCase() == "success") {
            this.RegistrationResponce = res.data;
            this.RegistrationResponce.PracticeName = this.practice_name;
            let data = this._phrutilService.encrypt(this.RegistrationResponce);
            localStorage.setItem('PatientInfo', data);
            localStorage.setItem("AuthTokenwebServices",res.data.accessTokenResponse.accessToken); 
            localStorage.setItem("RefreashTokenwebServices", res.data.accessTokenResponse.refreshToken);
            let text;
            this.translateService.get('RegistrationPage.registrationAlerts.patient_Register_successfully').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showSuccess(text);
            //this._phrutilService.showSuccess("Patient Register successfully");
            if (this.practice_code != '1013675'){
              this._router.navigateByUrl('/appointment');
            } else {
              //this._router.navigateByUrl('/pay_type');
              this._router.navigateByUrl('/registration-consent-form');
            }
           
          }
          else {
            let text = "Service is not available, please try later.";
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
            //this._phrutilService.showError("Service is not available, please try later.");
          }
        }, (error: any) => {
          this.spinner.hide();
          
        });
      }
      else
      {//OTP removed as per Sir Adeel serwer
        //if(!this.verifiedCellPhone && this.checkFieldValidaiton() && this.registrationForm.valid)
        //{
        //  this._phrutilService.showInfo("Please verify your Cell phone");
        //}
      }
    }
    
    checkFieldValidaiton() {
      if(this.registrationForm.get('dob'))
      {
        const dobControl = this.registrationForm.get('dob') as FormControl;
        if (dobControl.value) {
          if((new Date(this.maxDate)) < (new Date(dobControl.value)))
          {
            let text;
            this.translateService.get('RegistrationPage.registrationAlerts.fture_date_of_birth_is_not_allowed').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showInfo(text);
            return false;
          }
        }
      }
      if (!this.registrationForm.get('cell')!.value ||this.registrationForm.get('cell')!.value.length == 0) {
        this.isNotCellPhone = true;
        return false;
      }
      else {
        this.isNotCellPhone = false;
        return true;
      }
    }
    
    phoneLink: string;
    linkType: string;
    otpResp: any = null;
    SendOTP() {
      this.registrationForm.markAllAsTouched();
      if (!this.checkFieldValidaiton() && this.registrationForm.invalid) {
        return;
      }
      
      let p = this.registrationForm.get('cell')!.value.replace(/\D/g, '');
      
      this.phoneLink = p;
      this.linkType = 'phone number';
      this.phoneLink = '*** *** **' + this.phoneLink.substring(this.phoneLink.length-4, this.phoneLink.length);
      
      let obj = {
        "applicationName": "BreezeCheckin",
        "userName": p,
        "deviceInfo": "web",
        "appDisplayName": "Breeze Checkin"
      };
      this.spinner.show();
      this._registor.SendOTP(obj).subscribe((res: any) => {
        this.spinner.hide();
        if(res.status == true && res.message.toLowerCase() == 'otp sent'){
          $('#verifycode').modal('show');
          this.otpResp = res;
          $('#ngotp .ng-otp-input-wrapper').removeClass("wrapper");
          this.OTPTimer(179);
          this.ngOtpInput.setValue('');
        }
        else {
          this._phrutilService.showError(res.message);
        }
      }, (error: any) => {
        this._phrutilService.showError(error.toString());
        this.spinner.hide();
      });
    }
    
  //otp timer starts
  m: string = '00';
  s: string = '00';
  timer: any;
  remainingTime : number = 0;
  OTPTimer(remaining: any) {
    this.remainingTime = remaining;
    this.m = Math.floor(remaining/60).toString();
    this.s = (remaining % 60).toString();
    this.m = Number(this.m) < 10 ? '0' + this.m : this.m;
    this.s = Number(this.s) < 10 ? '0' + this.s : this.s;

    this.timer = setTimeout(() => {
      if (remaining >= 1) {
        remaining -= 1;
        this.OTPTimer(remaining);
      }
      else {
        return;
      }
    }, 1000);
  }
    InvalidOTP:Boolean=false;
    verResp: any = null;
    otpEntered: boolean = true;
    verifyOTP() {
      if(this.otpResp == null){
        return;
      }
      if (Number(this.s) == 0 && Number(this.m) == 0) {
        let text = "Code expired. Tap resend code and try again.";
        this.translateService.get('Alerts.code_expired').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Code expired. Tap resend code and try again.");
        return;
      }
      
      if (this.otp && this.otp.length == 4) {
        this.otpEntered = true;
        let obj = {
          "deviceInfo": "web",
          "notifier": this.otpResp.data,
          "otp": this.otp
        };
        this.spinner.show();
        this._registor.VerifyOTP(obj).subscribe((res: any) => {
          this.isVerifying = false;
          this.spinner.hide();
          this.verResp = res;
          if (res.status == true && res.message == "OTP verified successfully") { 
            $('#verifycode').modal('hide');
            this.verifiedCellPhone = true;
          }
          else if(res.message.includes('failed')){
            this.InvalidOTP=true;
            //this._phrutilService.showError("Invalid OTP Code. Try again.");
          }
        }, (error: any) => {
          this.isVerifying = false;
          this._phrutilService.showError(error.toString());
          this.spinner.hide();
        });
      }
      else{
        this.otpEntered = false;
      }
    }
    
    otp: string = '';
    isVerifying : boolean = false;
    onOtpChange(otp: any) {
      if(this.isVerifying){
        return;
      }
      this.otp = otp;
      if(this.otp.length == 4){
        this.isVerifying = true;
        this.verifyOTP();
      }
    }
    
    providerLocation:any;
    getLocation(practice_code:any) {
      this.spinner.show();
      this._registor.GetLocation(practice_code).subscribe((res:any) => {
        this.spinner.hide();
        if(res.data && res.data.locations.length!=0)
        {
          let LocationTemp = res.data.locations as LocationModel[];
          let LocationTemp_1 =  LocationTemp.filter(data=>data.locationName != "");
          this.providerLocation = LocationTemp_1;
          debugger;
        }
        else
        {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
          return;
        }
      },
      (error:any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      });
    }
    
    VerifyPractice(practice_code :any) {
      this.spinner.show();
      this._registor.VerifyPracticeCode(practice_code).subscribe((res:any) => {
        this.spinner.hide();
        if(res.data && res.statusCode==200)
        {
          this.practice_code=res.data.practice_Code;
          this.practice_name = res.data.prac_Name;
          this._phrutilService.setNavpracName(this.practice_name);
          this.getLocation(this.practice_code);
        }
        else
        {
          $("#isNotValid_link").modal("show");
          return;
        }
      },
      (error:any) => {
        this.spinner.hide();
        $("#isNotValid_link").modal("show");
      });
    }
    
    validateEmailAddress(event:any)
    {
      if(event.value.length>0)
      {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.value))
        {
          this.isValidEmail=true;
        }
        else
        {
          this.isValidEmail=false;
        }
      }
      else
      {
        this.isValidEmail=true;
      }
    }

    confirmBack(){
      this.reset();
      this.backPage();
    }

    backPage()
    {
      if(this.registrationForm.dirty){
        $('#confirmModal').modal('show');
        return;
      }
      this._phrutilService.setTitle('Breeze Check-in');
      this.location.back();
    }

    clearTimer(){
      clearTimeout(this.timer);
      this.timer = 0;
    }
    
    ngOnDestroy(): void {
      clearTimeout(this.timer);
      this.timer = 0;
    }

  }
